"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function FolderRestoreIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M23.874,15.058a5.712,5.712,0,0,0-11.392-.333l-.982-.9-1.15,1.251,2.606,2.4a.851.851,0,0,0,1.2-.049l2.4-2.606L15.3,13.664l-1.119,1.215A4.01,4.01,0,0,1,18,11.283a4.013,4.013,0,0,1,4.177,3.845,4.02,4.02,0,0,1-3.844,4.179H2.191a.37.37,0,0,1-.37-.369V5.063a.37.37,0,0,1,.37-.37H6.142A.376.376,0,0,1,6.4,4.8L7.9,6.3a2.079,2.079,0,0,0,1.463.606H19.752v-1.7H9.366A.378.378,0,0,1,9.1,5.1l-1.5-1.5a2.08,2.08,0,0,0-1.463-.607H2.191A2.071,2.071,0,0,0,.122,5.063V18.938a2.07,2.07,0,0,0,2.069,2.068H18.468V21A5.723,5.723,0,0,0,23.874,15.058Zm-10.393.587L13.32,15.5l.309-.012Z" })));
}
exports.default = FolderRestoreIcon;
